import { render, staticRenderFns } from "./dynamic-document-event-configuration-template.vue?vue&type=template&id=41a65420&scoped=true&"
import script from "./dynamic-document-event-configuration-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-event-configuration-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a65420",
  null
  
)

export default component.exports